
riot.tag2('export-products-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Экспорт</div>\n    </yield>\n    <yield to="body">\n      <div id="myProgress" style="width: 100%; background-color: #ccc;" if="{loader}">\n        <div id="myBar" style="width: 0%; height: 30px; background-color: #0782C1; text-align: center; line-height: 30px; color: white;">0%</div>\n      </div>\n      <form onchange="{change}" onkeyup="{change}" if="{!loader}">\n\n        <div class="container-fluid">\n          <table class="table table table">\n            <thead>\n              <tr>\n                <th>#</th>\n                <th>Тип</th>\n                <th>Вставка в импорт</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr each="{i, v in units}">\n                <td>{i}</td>\n                <td style="width: 80%;">\n                  <div style="width: 180px; overflow: hidden;">{v.column || \'Пустая строка\'}</div>\n                </td>\n                <td style="width: 20%;">\n\n\n\n\n\n\n                  <input onclick="{switch}" __checked="{(v.checkbox == &quot;Y&quot;)}" type="checkbox" value="{i}">\n                </td>\n              </tr>\n            </tbody>\n          </table>\n\n\n\n\n\n\n          <div class="checkbox-inline">\n            <label>\n              <input onclick="{switchMod}" __checked="{(expModif == &quot;Y&quot;)}" type="checkbox">Экспортировать параметры\n            </label>\n          </div>\n          <div class="checkbox-inline" if="{parent.opts.idGroup}">\n            <label>\n              <input onclick="{switchGroup}" __checked="{(expGroup == &quot;Y&quot;)}" type="checkbox">Экспортировать выбранную группу\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}" if="{!loader}">Экспорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

/*
* ПРОГРУЗКА СТРАНИЦЫ
* statusPreview - параметр-светофор, при значении true, файл excel не создается
*/
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    var data = {
        'statusPreview': true
    };
    opts.idGroup = opts.idGroup || false;
    // получение колонок из браузера и БД
    API.request({
        object: 'Product',
        method: 'Export',
        data: data,
        success: function success(response) {
            modal.units = {};
            modal.columns = response['headerCSV'];
            modal.expModif = localStorage.getItem('shop24_export_modif') || 'N';
            modal.expGroup = localStorage.getItem('shop24_export_group') || 'N';
            var jsonUnits = JSON.parse(localStorage.getItem('shop24_export_products') || '{}');
            localStorage.removeItem('shop24_import_products');

            // слияние данных (данные браузера в приоритете)
            for (var i = 0; i < modal.columns.length; i++) {
                if (jsonUnits[i] && jsonUnits[i].column && jsonUnits[i].column == modal.columns[i]) modal.units[i] = jsonUnits[i];else modal.units[i] = {
                    'column': modal.columns[i],
                    'checkbox': 'Y'
                };
            }
            modal.update();
        }
    });

    // переключатель чекбокса
    modal.switch = function (e) {
        var i = e.target.value;
        if (modal.units[i].checkbox == 'Y') {
            delete modal.units[i].checkbox;
            modal.units[i].checkbox = 'N';
        } else {
            delete modal.units[i].checkbox;
            modal.units[i].checkbox = 'Y';
        }
        modal.update();
    };

    // переключатель чекбокса Модификаций
    modal.switchMod = function (e) {
        if (modal.expModif == 'Y') modal.expModif = 'N';else modal.expModif = 'Y';
        modal.update();
    };

    modal.switchGroup = function (e) {
        if (modal.expGroup == 'Y') modal.expGroup = 'N';else modal.expGroup = 'Y';
        modal.update();
    };
});

// отправка
self.submit = function () {
    var modal = self.tags['bs-modal'];
    modal.loader = true;

    // сохранение профиля экспорта (растановка чекбоксов)
    var profile = (0, _stringify2.default)(modal.units);
    localStorage.setItem('shop24_export_products', profile);
    localStorage.setItem('shop24_export_modif', modal.expModif);
    localStorage.setItem('shop24_export_group', modal.expGroup);

    /**
    * прикрепляем к профилю соотношения полей
    * объявляем переменные
    * запускаем цикл запросов к API
    *   отправляем в API соотношения полей и страницу
    *     в циклах формируются временные файлы на сервере
    *     возвращается колво страниц
    *   если страница == общему колву страниц
    *     загружаем файл
    *     закрываем всплывающее окно, обновляем страницу
    *     выходим из цикла
    */

    var cycleNum = 0;
    var pages = null;
    var units = modal.units;
    var expModif = modal.expModif;

    var idGroup = 0;
    var params = [];
    if (opts.idGroup && modal.expGroup == 'Y') {
        idGroup = opts.idGroup;
    }
    params = opts.params;

    //console.log(opts.idGroup, modal.expGroup, idGroup);
    function repReq(pages, cycleNum, units, expModif, idGroup, params) {

        var data = {
            'cycleNum': cycleNum,
            'columns': units,
            'expModif': expModif,
            'idGroup': idGroup,
            'params': params
        };
        API.request({
            object: 'Product',
            method: 'Export',
            data: data,
            success: function success(response) {
                pages = response.pages;

                // прогресс-бар
                var elem = document.getElementById("myBar");
                var width = (cycleNum + 1) / pages * 100;
                elem.style.width = width + '%';
                elem.innerHTML = Math.round(width) * 1 + '%';

                if (cycleNum != pages - 1) {
                    // переход в следующий цикл
                    cycleNum = cycleNum + 1; // подгружаем следующую страницу
                    return repReq(pages, cycleNum, units, expModif, idGroup, params);
                } else {
                    // закрытие / обновление / выход из цикла
                    var a = document.createElement('a');
                    a.href = response.url;
                    a.download = response.name;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    modal.modalHide();
                    //observable.trigger('products-reload')
                    //observable.trigger('categories-reload')
                    //observable.trigger('special-reload')
                    observable.trigger('products-exports-end');
                }
            }
        });
    }
    repReq(pages, cycleNum, units, expModif, idGroup, params);
};
});


// WEBPACK FOOTER //
// ./modals/export-products-modal.tag